// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + (chunkId === 594 ? "about" : chunkId) + "." + {"202":"0f4b5b3f","506":"25a3bdac","594":"27dd5a43","720":"47994680"}[chunkId] + ".js";
};